import { render, staticRenderFns } from "./MoveOpportunity.vue?vue&type=template&id=4e8c1c4a&scoped=true"
import script from "./MoveOpportunity.vue?vue&type=script&lang=js"
export * from "./MoveOpportunity.vue?vue&type=script&lang=js"
import style0 from "./MoveOpportunity.vue?vue&type=style&index=0&id=4e8c1c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c1c4a",
  null
  
)

export default component.exports